module.exports = __webpack_public_path__ + "img/1.caf7dc7c.jpg";